import React from "react";
import styled from 'styled-components';
import { Button, Icon, Popup } from 'semantic-ui-react'

const LeverButton = styled.div`
      display: inline-block;
`;

const TextBox = styled.div`
    background-color: ${props => props.theme.background};
    color: ${props => props.theme.color};
    text-shadow: none;
    background-image: none;
    font-size: 1.14285714rem;
    min-height: 1em;
    height: 5em;
    align-items: center;
    display: flex;
    width: 175px;
    outline: 0;
    border: none;
    vertical-align: baseline;
    justify-content: center;
    font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
    margin: 0 .25em 0 0;
    padding: .78571429em 1.5em .78571429em;
    text-transform: none;
    font-weight: 700;
    line-height: 1em;
    font-style: normal;
    text-align: center;
    text-decoration: none;
    border-top-right-radius: .28571429rem;
    border-top-left-radius: .28571429rem;
    box-shadow: 0 0 0 0 rgba(34,36,38,.15) inset;
`;

const AttachedButton = styled(Button)`
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  
  background-color: ${props => props.theme.background} !important;
  
  &:active, &.active {
     background-color: ${props => props.theme.active} !important;
  }
  &:hover {
     background-color: ${props => props.theme.active} !important;  
  }
`;

const themes = {
  'blue': {
    background: '#2185d0',
    active: '#1279c6',
    color: '#fff'
  },
  'grey': {
    background: '#ccc',
    active: '#bbb',
    color: '#000'
  },
  orange: {
    background: '#f59542',
    active: '#c46e23',
    color: '#fff'
  },
  purple: {
    background: '#a333c8',
    active: '#8d20b0',
    color: '#fff'
  },

};

const InfoIcon = styled.div`
  position: absolute;
  bottom: 45px;
  right: 5px;
`;

const InfoContainer = styled.div`
  max-width: 600px;
`;

const InfoComponent = props => {
  if (!props.info) {
    return null;
  }
  return (
    <InfoIcon>
      <Popup flowing hoverable trigger={<Icon circular color="blue" size="small" inverted name="info" />}>
        <InfoContainer dangerouslySetInnerHTML={{__html: props.info}} />
      </Popup>
    </InfoIcon>
  );
};

export default (props) => {
  const states = ['L', 'C', 'H'];
  return (
    <LeverButton  theme={themes[props.theme || 'blue']}>
      <TextBox  theme={themes[props.theme || 'blue']}>
        {props.text}

        <InfoComponent info={props.info}/>
      </TextBox>
      <Button.Group>
        {
          states.map((state, key) =>
            <AttachedButton
              key={key}
              theme={themes[props.theme || 'blue']}
              onClick={() => props.handleClick(state)}
              active={props.state === state}>{state}</AttachedButton>
          )
        }

      </Button.Group>
    </LeverButton>
  )
}

const exports = {
  LeverButton,
  TextBox,
  AttachedButton,
  themes
};

export {
  exports as LeverButtonComponents
}